const accountCenterUrl = process.env.NEXT_PUBLIC_ACCOUNT_CENTER_URL;

export const NavbarLoginButton = () => (
  <button
    type="button"
    className="navbar-login-button"
    onClick={() => window.location.assign(`${accountCenterUrl}/login`)}
  >
    Log In
  </button>
);
